import React from "react";
import { ReactComponent as Logo } from "assets/images/house_scan_logo_white.svg";
import { ReactComponent as InstagramIcon } from "assets/icons/instagram.svg";
import personAvatar from "assets/images/WhatsApp Image 2024-12-04 at 17.00.20.jpeg";

const Footer = () => {
  return (
    <div className="bg-primary px-5 pb-[130px] md:pb-[42px]">
      <div className="max-w-[1134px] mx-auto">
        <div className="pt-[80px] md:pt-[94px]">
          <div className="bg-white pb-[25px] md:pb-0 md:h-[341px] h-fit pt-[72px] md:pt-[96px] max-w-[920px] mx-auto px-[20px] sm:px-[43px] relative rounded-[5px]">
            <img
              src={personAvatar}
              alt="avatar"
              className="w-[104px] md:w-[118px] h-[104px] md:h-[118px] rounded-full object-cover absolute -top-[44px] left-1/2 -translate-x-1/2"
            />
            <h2 className="text-[28px] text-black font-bold leading-[33.89px] text-center">
              Come nasce HouseScan
            </h2>
            <p className="leading-[28px] mt-[6px] md:mt-[18px] font-normal text-[16px] text-black text-center">
              Ciao siamo Sabato e Lorenzo i founders di Housescan. La brutta
              esperienza che ho vissuto nel cercare casa tra mille portali
              immobiliari e la scarsità delle informazioni ci ha spinto a creare
              una piattaforma che semplificasse la ricerca e organizzasse gli
              annunci tutto in un unico posto. Così nasce Housescan!
            </p>
            <h4 className="font-bold text-center mt-[10px]">
              Sabato Manzo e Lorenzo Magni, Founders
            </h4>
          </div>
        </div>
        <div className="flex items-center justify-between mt-[34px] flex-col space-y-[25px] md:space-y-0 md:flex-row">
          {/* <img src={logo} alt="Logo"  /> */}
          <Logo className="w-[180px] h-[38px]" />
          <div className="flex items-center justify-center space-x-[11px]">
            <a href="https://www.instagram.com/housescan.it/" target="_blank">
              <InstagramIcon className="social-icon" />
            </a>
          </div>
        </div>
        <div className="mt-5 flex items-center justify-center">
          <a
            href="https://alphardlabs.com/"
            target="_blank"
            className="cursor-pointer text-center text-white "
          >
            Credits
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
